import React from "react";
import { Stack } from "@mui/material";

import LaborMaterialsTableRow from "./LaborMaterialsTableRow";

const LaborMaterialsTableBody = ({ fields = [], remove = () => {} }) => {
  return (
    <Stack>
      {fields?.map((item, idx) => {
        const key = item.id;
        const props = { idx, item, remove };
        return <LaborMaterialsTableRow key={key} {...props} />;
      })}
    </Stack>
  );
};

export default LaborMaterialsTableBody;
